export const isObject = function(el) {
  return typeof el === "object" && el !== null;
};
